import React from 'react';
import deleteIcon from '../assets/delete.svg';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const DeleteModal = ({ isOpen, employeeToDelete, removeEmployee, type }) => {
  if (!isOpen || !employeeToDelete) return null;

  const email = employeeToDelete?.email || '';
  const key = localStorage.getItem('key') || '';

  const handleDeleteChanges = async () => {
    const data = new URLSearchParams({ email, key, type });

    try {
      const response = await fetch(
        'https://app.mindstreamsoft.com/crp_employee.php',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: data,
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result?.message || `Server Error: ${response.status}`);
      }

      toast.success('Employee deleted successfully!', {
        autoClose: 2000,
        style: { zIndex: 1051 },
      });

      removeEmployee((prev) => prev.filter((emp) => emp.email !== email));
    } catch (error) {
      console.error('Error:', error);
      toast.error(
        error.message || 'Failed to delete employee. Please try again.'
      );
    }
  };

  const handleBackToDashboard = () => {
    window.location.reload();
  };

  return (
    <div
      className='d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100'
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
        zIndex: 1050,
        backdropFilter: 'blur(2px)',
      }}
    >
      <div
        className='d-flex flex-column justify-content-center align-items-center bg-white shadow'
        style={{
          width: '90%',
          maxWidth: '700px',
          height: '500px',
          borderRadius: '20px',
          padding: '40px',
        }}
      >
        <div
          className='d-flex justify-content-center align-items-center mx-auto mb-3'
          style={{ width: '60px', height: '60px', borderRadius: '50%' }}
        >
          <img src={deleteIcon} alt='delete icon' />
        </div>
        <h3 className='fw-bold text-center mb-5 mt-3'>Delete Employee</h3>
        <p
          style={{
            textAlign: 'center',
            marginBottom: '30px',
            color: '#1f1f21',
          }}
        >
          Are you sure you want to delete the employee{' '}
          <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
            {employeeToDelete?.name}
          </span>{' '}
          record?
        </p>
        <input type='hidden' value={employeeToDelete?.email} />
        <div
          className='d-flex flex-wrap justify-content-center gap-3'
          style={{ width: '100%' }}
        >
          <button
            className='btn text-white px-4'
            style={{
              backgroundColor: '#ff7a00',
              padding: '5px 20px',
              borderRadius: '8px',
              fontWeight: '600',
              cursor: 'pointer',
            }}
            onClick={handleDeleteChanges}
          >
            Delete Record
          </button>
          <button
            className='btn px-4'
            style={{
              backgroundColor: '#fff',
              color: '#1f1f21',
              border: '1px solid #969696',
              padding: '5px 20px',
              borderRadius: '8px',
              fontWeight: '600',
              cursor: 'pointer',
            }}
            onClick={handleBackToDashboard}
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
